<template>
    <b-table stacked="md" :items="items" :fields="recordFields" striped small>
            <template v-slot:table-caption>
                <div>*Pending Review</div>
                <div>**Guinness World Record</div>
            </template>
            <template v-slot:cell(time)="data">
                <b-link v-if="data.item.video" :href="data.item.video">{{formatTimeBasedOnDate(data.item.time, data.item)}}</b-link>
                <span v-else>{{formatTimeBasedOnDate(data.item.time, data.item)}}</span>
            </template>
        </b-table>
</template>

<script>
import { formatTimeBasedOnDate } from '@/common/times';

export default {
    data() {
        return {
            recordFields: [{
                key: "order",
                sortable: true
            }, {
                key: "event",
                sortable: true
            }, {
                key: "division",
                sortable: true
            }, {
                key: "time",
                sortable: true
            }, {
                key: "date",
                sortable: true,
                formatter: value => value.toLocaleDateString()
            }, {
                key: "location",
                sortable: true
            }]
        };
    },
    methods: {
        formatTimeBasedOnDate: formatTimeBasedOnDate
    },
    props: ["items"]
}
</script>